var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.555 6.94-3.85-3.645a1 1 0 0 0-1.435 0 1 1 0 0 0 0 1.41L12.77 7H1a1 1 0 0 0 0 2h11.755l-2.5 2.295a1.001 1.001 0 0 0 0 1.415 1.025 1.025 0 0 0 1.435 0l3.85-3.65a1.5 1.5 0 0 0 0-2.12h.015Z"
  })));
};
export default SvgArrowRight;